var _defs, _rect, _g, _g2, _text, _g3, _text2, _g4, _text3, _g5, _text4, _g6, _text5, _g7, _text6, _g8, _text7, _g9, _g10, _g11, _g12, _text8, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _text9, _g26, _text10, _g27, _text11, _g28, _text12, _g29, _text13, _g30, _text14, _g31, _text15, _g32, _text16, _g33, _text17, _g34, _text18, _g35, _text19, _g36, _text20, _g37, _text21, _g38, _text22, _g39, _text23, _g40, _text24, _g41, _text25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSme1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "870px",
    height: "500px",
    viewBox: "-0.5 -0.5 870 500",
    style: {
      backgroundColor: "rgb(255, 255, 255)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 110 430 L 110 56.71",
    fill: "none",
    stroke: "#a9a9a9",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 114.5 62.35 L 110 53.35 L 105.5 62.35",
    fill: "none",
    stroke: "#a9a9a9",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 4,
    width: 69,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 67,
      height: 1,
      paddingTop: 24,
      marginLeft: 77
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 20,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", {
    style: {
      fontSize: 20
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 20
    }
  }, "Credit Strength")))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 111,
    y: 30,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "20px",
    textAnchor: "middle"
  }, "Credit..."))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 75,
    width: 80,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-end",
      width: 78,
      height: 1,
      paddingTop: 90,
      marginLeft: 20
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "right"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Extremely strong")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 98,
    y: 95,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "16px",
    textAnchor: "end"
  }, "Extremely..."))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 135,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-end",
      width: 58,
      height: 1,
      paddingTop: 150,
      marginLeft: 40
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "right"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Very strong")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 98,
    y: 155,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "16px",
    textAnchor: "end"
  }, "Very st..."))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 195,
    width: 100,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-end",
      width: 98,
      height: 1,
      paddingTop: 210,
      marginLeft: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "right"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Strong")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 98,
    y: 215,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "16px",
    textAnchor: "end"
  }, "Strong"))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 255,
    width: 100,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-end",
      width: 98,
      height: 1,
      paddingTop: 270,
      marginLeft: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "right"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Moderate")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 98,
    y: 275,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "16px",
    textAnchor: "end"
  }, "Moderate"))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 315,
    width: 100,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-end",
      width: 98,
      height: 1,
      paddingTop: 330,
      marginLeft: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "right"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Weak")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 98,
    y: 335,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "16px",
    textAnchor: "end"
  }, "Weak"))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 375,
    width: 50,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-end",
      width: 48,
      height: 1,
      paddingTop: 390,
      marginLeft: 50
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "right"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Very weak")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 98,
    y: 395,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "16px",
    textAnchor: "end"
  }, "Very w..."))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 110 430 L 503.29 430",
    fill: "none",
    stroke: "#a9a9a9",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 497.65 434.5 L 506.65 430 L 497.65 425.5",
    fill: "none",
    stroke: "#a9a9a9",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 174.5 90 L 470 90",
    fill: "none",
    stroke: "#a9a9a9",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2 2",
    pointerEvents: "stroke"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 174.5 90 L 470.5 90",
    fill: "none",
    stroke: "#a9a9a9",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2 2",
    pointerEvents: "stroke"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 510,
    y: 400,
    width: 109,
    height: 60,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 107,
      height: 1,
      paddingTop: 430,
      marginLeft: 511
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 18,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", {
    style: {
      fontSize: 18
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 18
    }
  }, "Non-repayment risk")))))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 565,
    y: 435,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "18px",
    textAnchor: "middle"
  }, "Non-repaymen..."))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 110 89.5 L 469 90",
    fill: "none",
    stroke: "#a9a9a9",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2 2",
    pointerEvents: "stroke"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 110 149.5 L 469 150",
    fill: "none",
    stroke: "#a9a9a9",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2 2",
    pointerEvents: "stroke"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 150 430 L 149.5 90",
    fill: "none",
    stroke: "#a9a9a9",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2 2",
    pointerEvents: "stroke"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 110 329.5 L 469 330",
    fill: "none",
    stroke: "#a9a9a9",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2 2",
    pointerEvents: "stroke"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 110 210.5 L 469 211",
    fill: "none",
    stroke: "#a9a9a9",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2 2",
    pointerEvents: "stroke"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 110 269.5 L 469 270",
    fill: "none",
    stroke: "#a9a9a9",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2 2",
    pointerEvents: "stroke"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 310.5 430 L 310 294",
    fill: "none",
    stroke: "#a9a9a9",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2 2",
    pointerEvents: "stroke"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 110 389.5 L 469 390",
    fill: "none",
    stroke: "#a9a9a9",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2 2",
    pointerEvents: "stroke"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 230.21 430 L 229.71 90",
    fill: "none",
    stroke: "#a9a9a9",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2 2",
    pointerEvents: "stroke"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 309.21 430 L 308.71 90",
    fill: "none",
    stroke: "#a9a9a9",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2 2",
    pointerEvents: "stroke"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 389.21 430 L 388.71 90",
    fill: "none",
    stroke: "#a9a9a9",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2 2",
    pointerEvents: "stroke"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 470.21 430 L 469 90",
    fill: "none",
    stroke: "#a9a9a9",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "2 2",
    pointerEvents: "stroke"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 390,
    cy: 390,
    rx: 24,
    ry: 24,
    fill: "rgb(255, 255, 255)",
    stroke: "#a9a9a9",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 50,
      height: 1,
      paddingTop: 393,
      marginLeft: 365
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #a9a9a9; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 15,
      fontFamily: "Helvetica",
      color: "rgb(169, 169, 169)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "SME-", /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 15
    }
  }, "9"))))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 390,
    y: 397,
    fill: "#a9a9a9",
    fontFamily: "Helvetica",
    fontSize: "15px",
    textAnchor: "middle"
  }, "SME-..."))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 390,
    cy: 330,
    rx: 24,
    ry: 24,
    fill: "rgb(255, 255, 255)",
    stroke: "#a9a9a9",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 50,
      height: 1,
      paddingTop: 333,
      marginLeft: 365
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #a9a9a9; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 15,
      fontFamily: "Helvetica",
      color: "rgb(169, 169, 169)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "SME-", /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 15
    }
  }, "8"))))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 390,
    y: 337,
    fill: "#a9a9a9",
    fontFamily: "Helvetica",
    fontSize: "15px",
    textAnchor: "middle"
  }, "SME-..."))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 310,
    cy: 330,
    rx: 24,
    ry: 24,
    fill: "rgb(255, 255, 255)",
    stroke: "#a9a9a9",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 50,
      height: 1,
      paddingTop: 333,
      marginLeft: 285
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #a9a9a9; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 15,
      fontFamily: "Helvetica",
      color: "rgb(169, 169, 169)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "SME-", /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 15
    }
  }, "7"))))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 337,
    fill: "#a9a9a9",
    fontFamily: "Helvetica",
    fontSize: "15px",
    textAnchor: "middle"
  }, "SME-..."))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 310,
    cy: 270,
    rx: 24,
    ry: 24,
    fill: "rgb(255, 255, 255)",
    stroke: "#a9a9a9",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 50,
      height: 1,
      paddingTop: 273,
      marginLeft: 285
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #a9a9a9; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 15,
      fontFamily: "Helvetica",
      color: "rgb(169, 169, 169)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "SME-", /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 15
    }
  }, "6"))))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 277,
    fill: "#a9a9a9",
    fontFamily: "Helvetica",
    fontSize: "15px",
    textAnchor: "middle"
  }, "SME-..."))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 230,
    cy: 270,
    rx: 24,
    ry: 24,
    fill: "rgb(255, 255, 255)",
    stroke: "#a9a9a9",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 50,
      height: 1,
      paddingTop: 273,
      marginLeft: 205
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #a9a9a9; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 15,
      fontFamily: "Helvetica",
      color: "rgb(169, 169, 169)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "SME-", /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 15
    }
  }, "5"))))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 277,
    fill: "#a9a9a9",
    fontFamily: "Helvetica",
    fontSize: "15px",
    textAnchor: "middle"
  }, "SME-..."))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 230,
    cy: 210,
    rx: 24,
    ry: 24,
    fill: "rgb(255, 255, 255)",
    stroke: "#a9a9a9",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 50,
      height: 1,
      paddingTop: 213,
      marginLeft: 205
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #a9a9a9; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 15,
      fontFamily: "Helvetica",
      color: "rgb(169, 169, 169)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "SME-", /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 15
    }
  }, "4"))))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 217,
    fill: "#a9a9a9",
    fontFamily: "Helvetica",
    fontSize: "15px",
    textAnchor: "middle"
  }, "SME-..."))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.5,
    cy: 210,
    rx: 24,
    ry: 24,
    fill: "rgb(255, 255, 255)",
    stroke: "#a9a9a9",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 50,
      height: 1,
      paddingTop: 213,
      marginLeft: 126
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #a9a9a9; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 15,
      fontFamily: "Helvetica",
      color: "rgb(169, 169, 169)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "SME-", /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 15
    }
  }, "3"))))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 151,
    y: 217,
    fill: "#a9a9a9",
    fontFamily: "Helvetica",
    fontSize: "15px",
    textAnchor: "middle"
  }, "SME-..."))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.5,
    cy: 150,
    rx: 24,
    ry: 24,
    fill: "rgb(255, 255, 255)",
    stroke: "#a9a9a9",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 50,
      height: 1,
      paddingTop: 153,
      marginLeft: 126
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #a9a9a9; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 15,
      fontFamily: "Helvetica",
      color: "rgb(169, 169, 169)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "SME-", /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 15
    }
  }, "2"))))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 151,
    y: 157,
    fill: "#a9a9a9",
    fontFamily: "Helvetica",
    fontSize: "15px",
    textAnchor: "middle"
  }, "SME-..."))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.5,
    cy: 90,
    rx: 24,
    ry: 24,
    fill: "#36486b",
    stroke: "#36486b",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 50,
      height: 1,
      paddingTop: 93,
      marginLeft: 126
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #ffffff; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 15,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "SME-", /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 15
    }
  }, "1"))))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 151,
    y: 97,
    fill: "#ffffff",
    fontFamily: "Helvetica",
    fontSize: "15px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "SME-..."))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 433,
    width: 72,
    height: 67,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 70,
      height: 1,
      paddingTop: 467,
      marginLeft: 435
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Very high default potential")))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 470,
    y: 471,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "16px",
    textAnchor: "middle"
  }, "Very high..."))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 433,
    width: 60,
    height: 67,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 467,
      marginLeft: 361
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "High default potential")))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 390,
    y: 471,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "16px",
    textAnchor: "middle"
  }, "High de..."))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 269.5,
    y: 433,
    width: 81,
    height: 27,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 79,
      height: 1,
      paddingTop: 447,
      marginLeft: 271
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Moderate")))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 451,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "16px",
    textAnchor: "middle"
  }, "Moderate"))))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 433,
    width: 60,
    height: 27,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 447,
      marginLeft: 201
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Low")))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 451,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "16px",
    textAnchor: "middle"
  }, "Low"))))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 130.5,
    y: 433,
    width: 40,
    height: 47,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 38,
      height: 1,
      paddingTop: 457,
      marginLeft: 132
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Very low")))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 151,
    y: 461,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "16px",
    textAnchor: "middle"
  }, "Very..."))))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 470,
    cy: 390,
    rx: 24,
    ry: 24,
    fill: "rgb(255, 255, 255)",
    stroke: "#a9a9a9",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 50,
      height: 1,
      paddingTop: 393,
      marginLeft: 445
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #a9a9a9; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 15,
      fontFamily: "Helvetica",
      color: "rgb(169, 169, 169)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "SME-", /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 15
    }
  }, "10"))))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 470,
    y: 397,
    fill: "#a9a9a9",
    fontFamily: "Helvetica",
    fontSize: "15px",
    textAnchor: "middle"
  }, "SME-..."))))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 669,
    y: 169.5,
    width: 200,
    height: 50,
    rx: 4,
    ry: 4,
    fill: "#36486b",
    stroke: "#36486b",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 198,
      height: 1,
      paddingTop: 195,
      marginLeft: 670
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #ffffff; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 32,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "SME-1")))), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 769,
    y: 204,
    fill: "#ffffff",
    fontFamily: "Helvetica",
    fontSize: "32px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "SME-1"))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 669,
    y: 234.5,
    width: 200,
    height: 100,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-end",
      justifyContent: "unsafe center",
      width: 198,
      height: 1,
      paddingTop: 332,
      marginLeft: 670
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 16,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 16
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      textAlign: "left",
      fontSize: 16
    }
  }, "Indicates that the company has\xA0"), /*#__PURE__*/React.createElement("b", {
    style: {
      textAlign: "left",
      fontSize: 16
    }
  }, "extremely strong"), /*#__PURE__*/React.createElement("span", {
    style: {
      textAlign: "left",
      fontSize: 16
    }
  }, "\xA0credit strength with\xA0"), /*#__PURE__*/React.createElement("b", {
    style: {
      textAlign: "left",
      fontSize: 16
    }
  }, "very low"), /*#__PURE__*/React.createElement("span", {
    style: {
      textAlign: "left",
      fontSize: 16
    }
  }, "\xA0non-repayment risk")))))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 769,
    y: 332,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "16px",
    textAnchor: "middle"
  }, "Indicates that the compan...")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSme1);
export default __webpack_public_path__ + "static/media/SME-1.debb82d5f6d43ecae9625828f731d569.svg";
export { ForwardRef as ReactComponent };